import { formatMoneyCurrency } from '@/shared/utils/formatMoneyDisplay';
import { parseTenThousandths } from '@/shared/utils/moneyArithmetic';

/** Formats an unsigned decimal string of up to four places as pounds, rounded by the money
 *  policy. Anything else renders an em dash. */
export const formatDecimalPounds = (amount: string): string => {
    const trimmed = amount.trim();
    const tenThousandths = parseTenThousandths(trimmed);
    return tenThousandths === null || tenThousandths < 0n || trimmed.startsWith('-')
        ? '—'
        : formatMoneyCurrency(trimmed, 'GBP');
};
